import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { motion } from 'framer-motion';
import { useMemo } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { b as base } from '../../unsorted/index2.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { B as BaseClickable } from '../BaseClickable/BaseClickable.js';
import { I as Icon } from '../Icon/Icon.js';
import { useGetCurrentSizeClass } from '../../hooks/useGetCurrentSizeClass.js';
import { hFlex } from '../../utils/sxChunks.js';
import { useTheme } from '../../hooks/useTheme.js';

var DEFAULT_SIMPLE_ICON_BUTTON_SIZE = "300";
var SIMPLE_ICON_BUTTON_SIZES = Object.keys(base.icon.size);

var _excluded$1 = ["icon", "iconVariant", "className", "sx", "iconSx", "size", "testId"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SimpleIconButton(_ref) {
  var icon = _ref.icon,
    iconVariant = _ref.iconVariant,
    className = _ref.className,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$iconSx = _ref.iconSx,
    iconSx = _ref$iconSx === void 0 ? {} : _ref$iconSx,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? DEFAULT_SIMPLE_ICON_BUTTON_SIZE : _ref$size,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "SimpleIconButton" : _ref$testId,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var sizeAsClass = useGetCurrentSizeClass(size, DEFAULT_SIMPLE_ICON_BUTTON_SIZE.toString(), SIMPLE_ICON_BUTTON_SIZES);
  var mergedSx = useMemo(function () {
    return merge(_objectSpread$1(_objectSpread$1({}, hFlex), {}, {
      alignItems: "center",
      justifyContent: "center",
      w: "base.icon.size.".concat(sizeAsClass),
      h: "base.icon.size.".concat(sizeAsClass),
      fontSize: "base.icon.size.".concat(sizeAsClass),
      fill: "base.color.text.body.secondary",
      transitionProperty: "fill",
      transitionDuration: "base.motion.normal.fast.cssDuration",
      transitionTimingFunction: "base.motion.normal.fast.cssEase",
      "&[disabled]": {
        cursor: "default"
      },
      "&:hover:not([disabled]), &:active:not([disabled])": {
        fill: "base.color.text.body.primary"
      }
    }), sx);
  }, [sx, sizeAsClass]);
  var mergedIconSx = useMemo(function () {
    return merge({
      w: "0.6666em",
      fill: "inherit"
    }, iconSx);
  }, [iconSx]);
  return jsx(BaseClickable, _objectSpread$1(_objectSpread$1({}, props), {}, {
    sx: mergedSx,
    testId: testId,
    className: "".concat(className !== null && className !== void 0 ? className : "", " SimpleIconButton SimpleIconButton--").concat(sizeAsClass),
    children: jsx(Icon, {
      icon: icon,
      variant: iconVariant,
      sx: mergedIconSx,
      className: "SimpleIconButton__icon",
      testId: "".concat(testId, "__icon")
    })
  }));
}
SimpleIconButton.displayName = "SimpleIconButton";

var _excluded = ["className", "rc"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ClearFieldButton(_ref) {
  var className = _ref.className,
    rc = _ref.rc,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    base = _useTheme.base;
  var rcWithFallback = useMemo(function () {
    return rc !== null && rc !== void 0 ? rc : jsx(motion.button, {
      type: "button",
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      transition: {
        ease: base.motion.normal.fast.jsEase,
        duration: base.motion.normal.fast.jsDuration
      }
    });
  }, [rc, base]);
  return jsx(SimpleIconButton, _objectSpread(_objectSpread({}, props), {}, {
    icon: "CloseWithCircle",
    iconVariant: "bold",
    className: "".concat(className !== null && className !== void 0 ? className : "", " ClearFieldButton"),
    rc: rcWithFallback
  }));
}
ClearFieldButton.displayName = "ClearFieldButton";

export { ClearFieldButton as C, DEFAULT_SIMPLE_ICON_BUTTON_SIZE as D, SimpleIconButton as S, SIMPLE_ICON_BUTTON_SIZES as a };
//# sourceMappingURL=ClearFieldButton.js.map
